:host {
  ::slotted(*) {
    stzh-header {
      margin-left: -$containerMargin;
      margin-right: -$containerMargin;

      @include mq($from: small) {
        margin-left: -$containerMarginSmall;
        margin-right: -$containerMarginSmall;
      }

      @include mq($from: medium) {
        margin-left: -$containerMarginMedium;
        margin-right: -$containerMarginMedium;
      }

      @include mq($from: large) {
        margin-left: -$containerMarginLarge;
        margin-right: -$containerMarginLarge;
      }

      @include mq($from: ultra) {
        margin-left: calc(
          (100vw - #{$containerMaxWidth} - var(--stzh-scrollbar-width, 0px)) /
            -2
        );
        margin-right: calc(
          (100vw - #{$containerMaxWidth} - var(--stzh-scrollbar-width, 0px)) /
            -2
        );
      }
    }

    stzh-banner,
    stzh-ghettobox,
    stzh-pagetitle,
    stzh-pagetitle-home,
    stzh-container,
    stzh-homepage-service-highlights,
    stzh-homepage-search,
    stzh-vbz-carousel,
    stzh-message[type="page-message"] {
      position: relative;
      left: 50%;
      right: 50%;
      margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
      margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
      width: calc(100vw - var(--stzh-scrollbar-width));
      max-width: calc(100vw - var(--stzh-scrollbar-width));
    }

    // stzh-section[variant="highlight"] {
    //   --padding-left: #{$containerMargin};
    //   --padding-right: #{$containerMargin};

    //   @include mq($from: small) {
    //     --padding-left: #{$containerMarginSmall};
    //     --padding-right: #{$containerMarginSmall};
    //   }

    //   @include mq($from: medium) {
    //     --padding-left: #{$containerMarginMedium};
    //     --padding-right: #{$containerMarginMedium};
    //   }

    //   @include mq($from: large) {
    //     --padding-left: #{space('xlarge')};
    //     --padding-right: #{space('xlarge')};
    //   }

    //   @include mq($to: large) {
    //     position: relative;
    //     left: 50%;
    //     right: 50%;
    //     margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    //     margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    //     width: calc(100vw - var(--stzh-scrollbar-width));
    //     max-width: calc(100vw - var(--stzh-scrollbar-width));
    //   }
    // }

    // stzh-row stzh-section[variant="highlight"] {
    //   @include spaceCurve('--padding-left', 'small');
    //   @include spaceCurve('--padding-right', 'small');

    //   @include mq($to: large) {
    //     left: initial;
    //     right: initial;
    //     margin-left: initial;
    //     margin-right: initial;
    //     width: initial;
    //     max-width: initial;
    //   }
    // }
  }
}

.stzh-container {
  @include container;

  // &--size-big {
  //   @include container($size: "big");
  // }

  &--has-no-margin {
    margin-left: auto;
    margin-right: auto;
  }
}
